<template>
  <div>
    <template v-if="value">
      <div>{{ formatIndexDate(value).date }}</div>
      <div class="mc-datetime">
        {{ formatIndexDate(value).time }}
      </div>
    </template>
    <template v-else> - </template>
  </div>
</template>

<script>
import { formatIndexDate } from '@/helpers/tzDate'

export default {
  props: {
    value: {
      type: String,
      default: null
    }
  },
  methods: {
    formatIndexDate
  }
}
</script>